import api from './url'
import { jwtClientAxios } from '.'
import type { TypeTestDiagnosisRequest, TypeTestQuestionsResponse, TypeTestResultResponse } from './model/typeTestType'

export const sendTypeTestAnswersApi = async (request: TypeTestDiagnosisRequest): Promise<TypeTestResultResponse> => {
  try {
    const response = await jwtClientAxios().post(api.typeTest.DIAGNOSIS_TYPE_TEST_QUESTIONS, request)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getTypeTestQuestionsApi = async (): Promise<TypeTestQuestionsResponse> => {
  try {
    const response = await jwtClientAxios().get(api.typeTest.TYPE_TEST_QUESTIONS)
    return response.data.data
  } catch (error) {
    console.error(error)
    throw error
  }
}
